import * as style from './style.scss'
import * as React from 'react'

const JumboTitle: React.FunctionComponent = ({ children }) => <div className={style.jumboTitle}>{children}</div>

export default JumboTitle
